export enum ReactionTooltipTextType {
    name = 1,
    senders = 2,
    nameAndSenders = 3,
}
